import {Component, ElementRef, AfterViewInit, OnInit, inject, OnDestroy} from '@angular/core';
import { Chart, registerables } from 'chart.js';
import {ApiBaseService, VendorsService} from '../../../../../../projects/vendors/src/public-api';
import { SectionTable } from '../../../../@domain/section-table';
import { ApiEnum } from '../../../../@application/enum/api.enum';
import {Subscription} from "rxjs";
import {BrandingService} from '../../../../@application/services/branding.service';
Chart.register(...registerables);

@Component({
    selector: 'app-table-status',
    templateUrl: './table-status.component.html',
    styleUrls: ['./table-status.component.scss'],
    standalone: false
})
export class TableStatusComponent implements OnInit, AfterViewInit,OnDestroy {

  sections: SectionTable[] = [];
  myCharts: any[] = [];
  elementRef = inject(ElementRef);
  apiBaseService = inject(ApiBaseService);
  vendorsService = inject(VendorsService);
  private brandingService = inject(BrandingService);
  newOrderSubscription!: Subscription;
  orderCloseSubscription!: Subscription;
  orderStatusSubscription!: Subscription;

  ngOnInit(): void {
    this.dataSubscriptions();
    this.getData();
  }

  private dataSubscriptions() {
    this.newOrderSubscription = this.vendorsService.newOrderSubject.subscribe({
      next: newOrder => {
        if (newOrder)
          this.getData()
      }
    })
    this.orderCloseSubscription = this.vendorsService.orderCloseSubject.subscribe({
      next: orderClose => {
        if (orderClose)
          this.getData()
      }
    })
    this.orderStatusSubscription = this.vendorsService.orderStatusSubject.subscribe({
      next: orderStatus => {
        if (orderStatus)
          this.getData()
      }
    })
  }

  ngAfterViewInit(): void {
    this.createCharts();
  }

  private getData() {
    this.apiBaseService.GET<SectionTable[]>([ApiEnum.RestaurantModule, ApiEnum.Section, ApiEnum.SectionTable])
      .subscribe(res => {
        // this.sections = res;
        this.sections = res.filter(section => section.tableResponses && section.tableResponses.length > 0);;
        setTimeout(() => this.createCharts(), 0);
      });
  }

  // private createCharts(): void {
  //   this.myCharts.forEach(chart => chart.destroy());
  //   this.myCharts = [];

  //   this.sections.forEach((section, index) => {
  //     const canvasElement = this.elementRef.nativeElement.querySelector(`#chart-${index}`);
  //     if (canvasElement) {
  //       const ctx = canvasElement.getContext('2d');

  //       const totalTables = section.tableResponses.length;
  //       const freeTables = section.tableResponses.filter(table => table.availabilityStatus === 1).length; // Assuming 1 means 'free'
  //       const inUseTables = totalTables - freeTables;



  //       const chartData = {
  //         labels: ['Free Tables', 'In-Use Tables'],
  //         datasets: [{
  //           label: `Table Status in ${section.name}`,
  //           data: [freeTables, inUseTables],
  //           backgroundColor: ['#46C710', '#D32029'],
  //           hoverOffset: 4
  //         }]
  //       };

  //       const newChart = new Chart(ctx, {
  //         type: 'doughnut',
  //         data: chartData,
  //         options: {
  //           responsive: true,
  //           cutout: 90,
  //           interaction: {
  //             intersect: false,
  //           },
  //           plugins: {
  //             legend: {
  //               display: true,
  //               position: 'bottom',
  //             },
  //             datalabels: {
  //               display: true,
  //               align: 'center',
  //               anchor: 'center',
  //               color: '#FFFFFF',
  //               formatter: function(value) {
  //                 return value.toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //               },
  //             },
  //             title: {
  //               display: false,
  //               text: 'Custom Chart Title',
  //             }
  //           }
  //         }
  //       });

  //       this.myCharts.push(newChart);
  //     }
  //   });
  // }
  private createCharts(): void {
    this.myCharts.forEach(chart => chart.destroy());
    this.myCharts = [];

    this.sections.forEach((section, index) => {
      const canvasElement = this.elementRef.nativeElement.querySelector(`#chart-${index}`);
      if (canvasElement) {
        const ctx = canvasElement.getContext('2d');

        // Loop through each table to generate chart data
        const totalTables = section.tableResponses.length;
        const tableLabels: string[] = [];
        const tableData: number[] = [];
        const tableColors: string[] = [];

        section.tableResponses.forEach((table, tableIndex) => {
          // Assign label for each table
          const tableStatus = table.availabilityStatus === 1 ? 'Free' : 'In Use';
          tableLabels.push(`Table ${tableIndex + 1} (${tableStatus})`);
          tableData.push(1); // Each table is represented as 1 unit

          // Set color based on availability status
          if (table.availabilityStatus === 1) {
            tableColors.push(this.brandingService.getBrandColor()); // Brand colour for free tables
          } else {
            tableColors.push('#D32029'); // Red for occupied tables
          }
        });

        // Create chart data with individual table sections
        const chartData = {
          labels: tableLabels,
          datasets: [{
            label: `Table Status `,
            data: tableData,
            backgroundColor: tableColors,
            hoverOffset: 4
          }]
        };

        // Create the pie chart
        const brandColor = this.brandingService.getBrandColor();
        const newChart = new Chart(ctx, {
          type: 'doughnut',
          data: chartData,
          options: {
            responsive: true,
            cutout: 90,
            interaction: {
              intersect: false,
            },
            plugins: {
              legend: {
                display: true,
                position: 'bottom',
                labels: {
                  generateLabels: function(chart) {
                    return [
                      {
                        text: 'Free',
                        fillStyle: brandColor,
                        strokeStyle: brandColor,
                        lineWidth: 1,
                        hidden: false,
                        index: 0
                      },
                      {
                        text: 'In Use',
                        fillStyle: '#D32029',
                        strokeStyle: '#D32029',
                        lineWidth: 1,
                        hidden: false,
                        index: 1
                      }
                    ];
                  }
                }
              },
              datalabels: {
                display: true,
                align: 'center',
                anchor: 'center',
                color: '#FFFFFF',
                formatter: function(value, context) {
                  const labels = context.chart.data.labels;
                  if (labels && Array.isArray(labels)) {
                    return labels[context.dataIndex];
                  }
                  return ''; // Fallback in case labels are undefined
                },
              },
              title: {
                display: false,
                text: 'Custom Chart Title',
              }
            }
          }
        });


        this.myCharts.push(newChart);
      }
    });
}


  ngOnDestroy(): void {
    this.newOrderSubscription.unsubscribe();
    this.orderCloseSubscription.unsubscribe();
    this.orderStatusSubscription.unsubscribe();
  }
}
